/**
 * Register all global UI components here
 */
import { FunctionComponent, useEffect, useState } from 'react';

import {
    GlobalNotificationContext,
    NotificationMethod,
} from '../../model/context/global-notif.context';

import Alert from '../common/notify/Alert';

const GlobalNotificationProvider: FunctionComponent = ({ children }) => {
    /**
     * Instructions on registering new Global Notifications
     */
    // 1. Create your states
    const [alertMsg, setAlertMsg] = useState<string>();

    // 2. Assign context methods
    const context: NotificationMethod = {
        alert: setAlertMsg,
    };

    // 3. If the states are gonna change automatically (e.g. after timout), modify them here
    useEffect(() => {
        if (alertMsg) {
            setTimeout(() => {
                setAlertMsg('');
            }, 4000);
        }
    }, [alertMsg]);

    return (
        <GlobalNotificationContext.Provider value={context}>
            {/* 4. Control the visibility */}
            <Alert text={alertMsg} show={!!alertMsg} />
            {children}
        </GlobalNotificationContext.Provider>
    );
};

export default GlobalNotificationProvider;
